<template>
    <div id="app">

        <SensorFinder ref="sensorfinder"></SensorFinder>
    </div>
</template>

<script>
    import SensorFinder from './components/SensorFinder.vue'

    export default {
        name: 'app',
        components: {
            SensorFinder
        }
    }
</script>

<style>
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .myTooltip {
        background-color: #fff;
        border: 1px solid #999;
        color: #000;
    }

    .tooltip-arrow {
        display: none !important;
        border-color: red;
    }
</style>
